import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import theme from '~/truck/theme'

export const TOCContainer = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-top: ${theme.spacing.relaxed}px;

  > *:not(:last-child) {
    margin-bottom: ${theme.spacing.cozy}px;
  }
`

export const ActionsContainer = styled.div`
  margin-top: ${theme.spacing.relaxed}px;
  text-align: right;

  ${up('lg')} {
    > button {
      padding: 0 ${theme.spacing.comfortable}px;
      width: ${theme.spacing.cozy * 30}px;
    }
  }
`
